import * as React from 'react';
import { CategoryData } from '../App';
import * as styles from '../css/CategoryHeader.less';

interface TemplateProps {
    category: CategoryData;
}


export class CategoryHeader extends React.Component<TemplateProps, any> {
    constructor(props: TemplateProps) {
        super(props);
    }

    render() {
        const cmsClasses = this.props.category.element_id ? ` cms-prezi-plugin-edit cms-plugin cms-plugin-${this.props.category.element_id}` : '';
        return (
            <section>
                <div className={ 'container' }>
                    <div className={ 'row' }>
                        <div className={ 'col-xs-12 ' + styles.templateHeroOffset + cmsClasses }>
                            <div className={ styles.templateHero } key={ this.props.category.slug }>
                                <div className={ 'col-xs-12 pad-zero' }>
                                    <div>
                                        <h1 className={ 'btm-18 ' + styles.categoryName }>{ this.props.category.name }</h1>
                                        <p className={ 'col-xs-12 col-lg-7 pad-zero ' + styles.descriptionBottom }>{ this.props.category.description }</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/CategoryHeader.tsx